var _defs, _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarplogo05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M963.24,507.94c-.55.65-55.2,64.37-126.54,65.3-42.51.67-84-21.59-123.18-65.81h0c-52.83-59.69-110.84-89.36-172.74-88.34-99.92,1.73-170.73,85.1-174.09,89.13h0c-39.28,44.37-80.8,66.69-123.39,66-71.34-.93-126-64.66-126.54-65.3l-49.14,51.7c3,3.57,73.92,87.45,174.14,89.18,1.06,0,2.13,0,3.2,0,60.59,0,118-30,169.87-88.68.53-.64,56.24-65.28,127-66.5,42.75-.77,84.32,21.41,123.7,65.8h0c51.92,58.65,108.94,88.37,169.53,88.37,1.07,0,2.14,0,3.2,0,100.22-1.73,171.17-85.6,174.14-89.17Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 540.13,
    cy: 694.34,
    r: 105.42
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 242.72,
    cy: 385.66,
    r: 105.42
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 835.29,
    cy: 385.66,
    r: 105.42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarplogo05);
export default __webpack_public_path__ + "static/media/Warp logo-05.762dfb9f2136386ddef83cfafea09304.svg";
export { ForwardRef as ReactComponent };